import React, { useEffect } from "react";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { useNeumaticos } from "../GestionNeumaticos/useNeumaticos";
import { useModal } from "../../../hooks/useModal";
import { Modal } from "../../components/modal/Modal";
import { formatState, notify } from "../../../utils/utils";
import { useBloqueoPantalla } from "../../../hooks/useBloqueoPantalla";
import { Select2 } from "../../components/forms/Select2";

export const Neumaticos = () => {

    const [isOpenModalRegistrar,openModalRegistrar,closeModalRegistrar] = useModal()
    const classNameInput = "containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 caret-white"   
    const [bloquearPantalla,desbloquearPantalla,ComponenteBloqueo] = useBloqueoPantalla()
    
    const {
        neumaticoDefault,
        neumatico,
        setNeumatico,
        listarNeumaticos,
        neumaticos,
        registrarEditarNeumatico,
        listarEstadosNeumaticos,
        estados,
        listarMedidasNumaticos,
        medidas,
        listarMarcasNeumaticos,
        marcas,
        editarValorNeumatico,
        editarNeumaticoSinOT
    } = useNeumaticos()

    useEffect(() => {
        (async () => {
            bloquearPantalla()
            await listarEstadosNeumaticos()
            await listarMedidasNumaticos()
            await listarMarcasNeumaticos()
            await listarNeumaticos()
            desbloquearPantalla()
        })()
    },[])

    const funcionEditarNeumaticoSinOT = async  () => {
        const jsonData = await editarNeumaticoSinOT()
        notify(jsonData.DesResultado,jsonData.CodResultado == 1 ? 'success' : 'error')
        if(jsonData.CodResultado == 1){
            closeModalRegistrar()
            await listarNeumaticos()
        }
    }
    
    return (
        <>
            <ComponenteBloqueo></ComponenteBloqueo>

            <ContenedorParametros
                titulo='Neumáticos' tablaId="tablaId"
            >   
                <BotonProcesar onClick={listarNeumaticos}></BotonProcesar>       
                
            </ContenedorParametros>

            <div className="containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla">
                <table id="tablaId" className="tableResponsive">
                    <thead>
                        <tr>
                            <th className="text-left">N</th>
                            <th className="text-left">CÓDIGO</th>
                            <th className="text-left">MEDIDA</th>
                            {/* <th>MARCA</th> */}
                            <th className="text-left">USUARIO</th>
                            <th className="text-right">M.INTERNA</th>
                            <th className="text-right">M.MEDIA</th>
                            <th className="text-right">M.EXTERNA</th>
                            <th className="text-right">PRESIÓN</th>
                            <th className="text-right">PROFUNDIDAD</th>
                            <th className="text-center">ESTADO</th>
                            <th className="text-center">CONDICIÓN</th>
                            <th className="text-left"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            neumaticos.length != 0 ?
                                neumaticos.map((data,i) => {
                                    return(
                                        <tr key={i+1}>
                                            <td className="text-left">{i+1}</td>
                                            <td data-label="Código" className="">{data.codigoNeumatico}</td>
                                            <td data-label="Medida" className="">{data.nomNeumaticoMedida}</td>
                                            {/* <td data-label="Marca" className="">{data.nomNeumaticoMarca}</td> */}
                                            <td data-label="Usuario" className="">{data.nomUsuarioActualizacion || '-'}</td>
                                            <td data-label="M.Interna" className="text-right">{(data.medidaInterna).toFixed(2)}</td>
                                            <td data-label="M.Media" className="text-right">{(data.medidaMedia).toFixed(2)}</td>
                                            <td data-label="M.Externa" className="text-right">{(data.medidaExterna).toFixed(2)}</td>
                                            <td data-label="Presión" className="text-right">{(data.presion).toFixed(2)}</td>
                                            <td data-label="Profundidad" className="text-right">{(data.profundidad).toFixed(2)}</td>
                                            <td data-label="Estado" className="text-center"><i title={data.nomEstado} className={`fa fa-circle ${data.codEstado == 1 ? 'text-green-600' : 'text-orange-600'}`} aria-hidden="true"></i></td>
                                            <td data-label="Estado" className="!flex justify-center lg:justify-between items-center">
                                                <div className={`${formatState(Number(data.codNeumaticoEstado))} w-[110px] h-fit text-center`}>{data.nomNeumaticoEstado}</div>
                                            </td>
                                            <td data-label="Opciones">
                                                <button onClick={() => {setNeumatico(Object.assign({},neumaticoDefault,data));openModalRegistrar()}} className="rounded w-[30px] h-[30px] bg-blue-600 text-xs"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                                            </td>
                                        </tr>
                                    )
                                })
                            :
                                <tr><td colSpan={12} className="text-center">No hay información...</td></tr>
                        }
                    </tbody>
                </table>
            </div>

            <Modal
                isOpen={isOpenModalRegistrar}
                title={`Editar neumático [${neumatico.codigoNeumatico}]`}
                closeModal={closeModalRegistrar}
                action={funcionEditarNeumaticoSinOT}
            >
                <div className="w-[700px] lg:w-full grid grid-cols-2  lg:grid-cols-1 gap-4 p-4">
                    <div className="grid grid-cols-3 grid-rows-4 gap-4">
                        <label className="col-span-1">Estado:</label>
                        <div className="col-span-2">
                            <Select2
                                value={neumatico.codNeumaticoEstado}
                                opciones={[
                                    {
                                        text: '-- Seleccionar --',
                                        value: 0
                                    },
                                    ...estados.map((data,i) => {
                                        return {
                                            text: data.nomNeumaticoEstado,
                                            value: data.codNeumaticoEstado
                                        }
                                    })
                                ]}
                                functionChangeValue={(valor) => editarValorNeumatico('codNeumaticoEstado',valor)}
                            ></Select2>
                        </div>
                        <label className="col-span-1">N.Medida:</label>
                        <div className="flex items-center justify-center gap-2 col-span-2">
                            <Select2
                                value={neumatico.codNeumaticoMedida}
                                opciones={[
                                    {
                                        text: '-- Seleccionar --',
                                        value: 0
                                    },
                                    ...medidas.map((data,i) => {
                                        return {
                                            text: data.nomNeumaticoMedida,
                                            value: data.codNeumaticoMedida
                                        }
                                    })
                                ]}
                                functionChangeValue={(valor) => editarValorNeumatico('codNeumaticoMedida',valor)}
                            ></Select2>
                        </div>
                        <label className="col-span-1">M.Interna</label>
                        <input value={neumatico.medidaInterna} type="number" min={0} onChange={e => editarValorNeumatico('medidaInterna',e.target.value)} className={`${classNameInput} col-span-2`} />
                        <label className="col-span-1">Presión:</label>
                        <input value={neumatico.presion} type="number" min={0} onChange={e => editarValorNeumatico('presion',e.target.value)} className={`${classNameInput} col-span-2`} />
                    </div>
                    <div className="grid grid-cols-3 grid-rows-4 gap-4">
                        {/* SE ESTA OLCULTANDO MARCA, MOSTRAR CUANDO EXISTA CRUD DE MARCAS */}
                        {
                            false ?
                            <>
                                <label className="col-span-1">Marca:</label>
                                <div className="flex items-center justify-center gap-2 col-span-2">
                                    <select value={neumatico.codNeumaticoMarca} onChange={e => editarValorNeumatico('codNeumaticoMarca',e.target.value)} className={classNameInput}>
                                        <option value={0}>--Seleccione--</option>
                                        {
                                            marcas.map((data,i) => <option key={i+1} value={data.codNeumaticoMarca}>{data.nomNeumaticoMarca}</option>)
                                        }
                                    </select>
                                </div>
                            </>
                            : <></>
                        }
                        <label className="col-span-1">M.Media:</label>
                        <input value={neumatico.medidaMedia} type="number" min={0} onChange={e => editarValorNeumatico('medidaMedia',e.target.value)} className={`${classNameInput} col-span-2`} />
                        <label className="col-span-1">M.Externa:</label>
                        <input value={neumatico.medidaExterna} type="number" min={0} onChange={e => editarValorNeumatico('medidaExterna',e.target.value)} className={`${classNameInput} col-span-2`} />
                        <label className="col-span-1">Profundidad:</label>
                        <input value={neumatico.profundidad} type="number" min={0} onChange={e => editarValorNeumatico('profundidad',e.target.value)} className={`${classNameInput} col-span-2`} />
                    </div>
                </div>
            </Modal>
        </>
    )
};
